// extracted by mini-css-extract-plugin
module.exports = {"IframeContainer":"styles_IframeContainer__181ge","Iframe":"styles_Iframe__1a0ig","visible":"styles_visible__3sg3h","Loader":"styles_Loader__3baen"};